import { Box, Typography } from "@mui/material";
import { faBookFont } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";

const ArticleAbstract = (
    {
        abstracts
    }: {
        abstracts: any
    }
) => {
    if (!abstracts) {
        return null;
    }

    return (
        <Box>
            <Typography
                component="h3"
            >
                <SpanTypography mr={.25} fontSize={'1.5rem'}>
                    <FontAwesomeIcon
                        icon={faBookFont}
                    />
                </SpanTypography>
                <SpanTypography fontSize={'1.7rem'}>
                    Abstract
                </SpanTypography>
            </Typography>
            <Box>
                {
                    abstracts.map((section: any, sectionIndex: number) => (
                    ( section.title && section.title !== '' ) ? (
                            <Box component="article" key={`abstract-section-${sectionIndex}`}>
                                {
                                    section.content.map((paragraph: string, index: number) => (
                                        <Box
                                            key={index}
                                            mb={.5}
                                            sx={{ textIndent: '1.5rem' }}
                                        >
                                            {
                                                index === 0 && section.title.trim().length > 0 && (
                                                    <Typography
                                                        variant="h4"
                                                        display="inline"
                                                        fontSize={'1.125rem'}
                                                        mr={.25}
                                                    >
                                                        {section.title}
                                                        {/:$/.test(section.title) ? "" : ":"}
                                                    </Typography>
                                                )
                                            }
                                            {
                                                section.content.length > 0 &&
                                                <Typography
                                                    variant="body1"
                                                    display="inline"
                                                    fontSize={'1rem'}
                                                >
                                                    {
                                                        ReactHtmlParser(paragraph)
                                                    }
                                                </Typography>
                                            }
                                        </Box>
                                    ))
                                }
                            </Box>
                        ) : (
                            <Box
                                component="aside"
                                key={`abstract-section-${sectionIndex}`}
                            >
                                {
                                    section.content.map((content: string, index: number) => (
                                        content.length > 0 &&
                                        <Typography
                                            key={index}
                                            fontSize={'1rem'}
                                            sx={{ textIndent: '1.5rem' }}
                                        >
                                            {
                                                ReactHtmlParser(content)
                                            }
                                        </Typography>
                                    ))
                                }
                            </Box>
                        )
                    ))
                }
            </Box>
        </Box>
    )
}

export default ArticleAbstract;
